import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../../../../../components/common/Typography';
import Button from '../../../../../components/common/Button';

const PersonalInfoConsentForm = ({ stepHandler, handleCheck }) => {
  const { t } = useTranslation('resultQuery');

  return (
    <div className="kakaoStep1" style={{ padding: '0px 9px' }}>
      <Typography variant="body1Bold">{t('kakaoModal.checkBoxLabel')}</Typography>
      <Typography variant="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
        {t('kakaoModal.agreement1')}
      </Typography>
      <div className="kakaoButton">
        <Button value={t('kakaoModal.button2')} fullWidth onClick={handleCheck} />
      </div>
    </div>
  );
};

export default PersonalInfoConsentForm;
